(function ($) {
    'use strict';

    function initShippingMethods() {
        // Handle shipping method selection changes
        $(document).on('change', '.woocommerce-shipping-methods input[type="radio"]', function() {
            let selectedInput = $(this);
            let shippingMethodsList = selectedInput.closest('.woocommerce-shipping-methods');
            
            // Remove active class from all items
            shippingMethodsList.find('li').removeClass('active');
            
            // Add active class to selected item
            selectedInput.closest('li').addClass('active');
        });

        // Handle click on shipping method item (not just the radio input)
        $(document).on('click', '.woocommerce-shipping-methods li', function(e) {
            // Don't trigger if clicking on the radio input itself
            if ($(e.target).is('input[type="radio"]')) {
                return;
            }
            
            let listItem = $(this);
            let radioInput = listItem.find('input[type="radio"]');
            
            // Only proceed if there's a radio input and it's not already checked
            if (radioInput.length && !radioInput.is(':checked')) {
                radioInput.prop('checked', true).trigger('change');
            }
        });

        // Initialize the active state on page load
        $('.woocommerce-shipping-methods input[type="radio"]:checked').each(function() {
            $(this).closest('li').addClass('active');
        });

        // Handle AJAX updates (like when shipping calculator updates)
        $(document.body).on('updated_cart_totals updated_shipping_method', function() {
            // Re-initialize active states after AJAX updates
            setTimeout(function() {
                $('.woocommerce-shipping-methods li').removeClass('active');
                $('.woocommerce-shipping-methods input[type="radio"]:checked').each(function() {
                    $(this).closest('li').addClass('active');
                });
            }, 100);
        });

        // Handle WooCommerce shipping calculator updates
        $(document.body).on('updated_wc_div', function() {
            setTimeout(function() {
                initShippingMethods();
            }, 100);
        });
    }

    // Initialize when document is ready
    $(document).ready(function() {
        initShippingMethods();
    });

    // Re-initialize after WooCommerce updates
    $(document.body).on('updated_cart_totals', function() {
        initShippingMethods();
    });

})(jQuery);
